export default __webpack_public_path__ + "static/promotionImage-1533a3e6c192d15906f778d444665cb5.webp";